import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TabsComponent } from '@shared/components/tabs/tabs.component';
import { TabComponent } from '@shared/components/tabs/tab.component';
import { AuthenticationComponent } from './authentication/authentication.component';
import { MyParametersComponent } from './my-parameters/my-parameters.component';
import { MyNotificationsComponent } from './my-notifications/my-notifications.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.scss'],
  imports: [
    TabsComponent,
    TabComponent,
    AuthenticationComponent,
    MyParametersComponent,
    MyNotificationsComponent,
    TranslatePipe,
  ],
})
export class MyProfileComponent implements OnInit {
  activeTab = undefined;

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.activeTab = params['tab'] || 'authentication';
    });
  }
}
